import { type FC } from "react";

import type { IConsensusLegend } from "./buildLegend";
import { TrendIndicator } from "./components/TrendIndicator";
import * as Styled from "./MarketsLegend.styles";

interface IConsensusLegendProps {
  consensus: IConsensusLegend;
  isDimmed: boolean;
}

export const ConsensusLegend: FC<IConsensusLegendProps> = ({
  consensus,
  isDimmed,
}) => {
  return (
    <Styled.Root $dimmed={isDimmed}>
      <Styled.Row>
        <Styled.MarketsBadge>{consensus.marketsLabel}</Styled.MarketsBadge>

        {consensus.platforms.map(({ key, name, color, chanceLabel }) => (
          <Styled.Item key={key}>
            <Styled.Line $color={color} $dashed={false} />
            <Styled.Label>{name}</Styled.Label>
            {chanceLabel && <Styled.Price>{chanceLabel}</Styled.Price>}
          </Styled.Item>
        ))}
      </Styled.Row>

      <Styled.Row>
        <Styled.Item>
          <Styled.ConsensusLine />
          <Styled.ConsensusLabel>consensus</Styled.ConsensusLabel>
        </Styled.Item>

        {consensus.nowLabel && (
          <Styled.Item>
            <Styled.Price>{consensus.nowLabel}</Styled.Price>

            {consensus.changeLabel && (
              <TrendIndicator
                isPositive={consensus.isPositiveChange}
                label={consensus.changeLabel}
              />
            )}
          </Styled.Item>
        )}

        {consensus.spreadLabel && (
          <>
            <Styled.Divider />
            <Styled.Item>
              <Styled.Caption>spread</Styled.Caption>
              <Styled.Price>{consensus.spreadLabel}</Styled.Price>
              <Styled.Caption>({consensus.spreadPointsLabel})</Styled.Caption>
            </Styled.Item>
          </>
        )}
      </Styled.Row>
    </Styled.Root>
  );
};
